<template>
  <div v-if="count" :class="classes">
    {{ count }}
  </div>
</template>

<script>
import SFetch from '@app/utils/sfetch'

export default {
  name: 'InboxUnreadCount',
  props: {
    url: {
      type: String,
      required: true,
    },
    className: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      count: 0,
    }
  },
  computed: {
    classes() {
      return (
        this.className ||
        'sf-label sf-label-danger sf-label-active sf-no-border tw-flex tw-items-center tw-justify-center tw-h-4 tw-min-w-[16px] tw-rounded-full tw-px-1 tw-leading-3'
      )
    },
  },
  created() {
    this.fetchUnreadCount()
    window.eventHub.$on('resetNotificationCount', this.fetchUnreadCount)
  },

  beforeUnmount() {
    window.eventHub.$off('resetNotificationCount', this.fetchUnreadCount)
  },

  methods: {
    fetchUnreadCount() {
      SFetch.json(this.url).then((data) => {
        this.count = data.count
      })
    },
  },
}
</script>
